import type { ISegmentControlsOption } from '~/features/ui-kit';

import FeatureFlagsTab from './FeatureFlagsTab.vue';
import DebugTab from './DebugTab.vue';
import EnvTab from './EnvTab.vue';
import ApiTab from './ApiTab.vue';

export class DevToolbarUiConfig {
  static tabsOptions: Array<ISegmentControlsOption> = [
    { label: 'FF', value: 'ff' },
    { label: 'API', value: 'api' },
    { label: 'Debug', value: 'debug' },
    { label: 'ENV', value: 'env' },
  ] as const;

  private static componentsMap = new Map<(typeof this.tabsOptions)[number]['value'], Component>([
    ['ff', markRaw(FeatureFlagsTab)],
    ['api', markRaw(ApiTab)],
    ['env', markRaw(EnvTab)],
    ['debug', markRaw(DebugTab)],
  ]);

  static getTabByValue(value: string) {
    return this.componentsMap.get(value);
  }
}
